module.exports = __webpack_public_path__ + "static/media/water bill.3f907277.png";